import React, { useState, useEffect } from "react";
import { Box, Typography, Dialog, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DoneIcon from "@mui/icons-material/Done";

import { useGlobalModalContext } from "../context/GlobalModalContext";
import { useClientContext } from "../context/ClientContext";

const CompanyProfileSubTab = ({ setShowCompanySubTab, boardOfDirectors, boardOfCommissioners, groupCompanies }) => {
  const { showModal, hideModal } = useGlobalModalContext();
  const { clientGroup, clientName } = useClientContext();
  const [readNews, setReadNews] = useState([]);
  const [formattedBoD, setFormattedBoD] = useState([]);
  const [formattedBoC, setFormattedBoC] = useState([]);
  const [formattedGroupCompanies, setFormattedGroupCompanies] = useState([]);

  useEffect(() => {
    if (boardOfDirectors && boardOfDirectors !== "") {
      const formatted = boardOfDirectors.map(director => 
        `${director.Name} - ${director.Position}`
      );
      setFormattedBoD(formatted);
    } else {
      setFormattedBoD([]);
    }
  }, [boardOfDirectors]);

  useEffect(() => {
    if (boardOfCommissioners && boardOfCommissioners !== "") {
      const formatted = boardOfCommissioners.map(commissioner => 
        `${commissioner.Name} - ${commissioner.Position}`
      );
      setFormattedBoC(formatted);
    } else {
      setFormattedBoC([]);
    }
  }, [boardOfCommissioners]);

  useEffect(() => {
    if (groupCompanies && groupCompanies.length > 0) {
      const formatted = groupCompanies.map(company => company.company_name);
      setFormattedGroupCompanies(formatted);
    } else {
      setFormattedGroupCompanies(["..."]);
    }
  }, [groupCompanies]);

  //console.log('groupCompanies', groupCompanies)

  const data = [
    {
      title: "Board of Commissioners",
      members: formattedBoC.length ? formattedBoC : ["..."],
    },
    {
      title: "Board of Directors",
      members: formattedBoD.length ? formattedBoD : ["..."],
    },
  ];

  const news = {
    Pertamina: [
      {
        id: 1,
        title: "Pertamina shareholders name new CEO, Chief commissioner",
        description:
          "The General Meeting of Shareholders of State energy company PT Pertamina on Monday, November 4, 2024, named Simon Aloysius Mantiri and Mochamad Iriawan as the new CEO and President Commissioner, respectively.",
      },
    ],
  };

  const handleTableView = () => {
    setShowCompanySubTab(false);
  };

  const handleReadNews = (newsId) => {
    if (!readNews.includes(newsId)) {
      setReadNews([...readNews, newsId]);
      // API call can be made here
      // Example: axios.post('/api/mark-news-read', { newsId });
    }
  };

  return (
    <Box
      className="rounded-md py-2 px-4"
      style={{
        boxShadow: "0px 2px 20px rgba(0, 0, 0, 0.1)",
        height: "60vh",
        overflowY: "auto",
      }}
    >
      <div className="flex justify-between items-center">
        <IconButton
          aria-label="<>"
          onClick={handleTableView}
          sx={{ height: 24, width: 24 }}
        >
          <ArrowBackIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </div>

      <div className="grid gap-y-6 ml-4">
        {/* Key Management Section */}
        <div>
          <div className="font-bold text-left text-xs mb-3">Key Management</div>
          <div className="grid grid-cols-2 gap-x-4">
            {data.map((board, index) => (
              <div key={index}>
                <div className="text-main font-bold text-xs mb-2">
                  {board.title}
                </div>
                <ul className="list-disc pl-4">
                  {board.members.map((member, i) => (
                    <li
                      key={i}
                      className={`text-black text-xs ${
                        i < board.members.length - 1 ? "mb-1" : ""
                      }`}
                    >
                      {member}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Group Companies Section */}
        <div>
          <div className="text-black font-bold text-left text-xs mb-3">
            Group Companies
          </div>
          <div className="grid grid-cols-2 gap-x-4">
            <ul className="list-disc pl-4">
              {formattedGroupCompanies
                .slice(0, Math.ceil(formattedGroupCompanies.length / 2))
                .map((company, index) => (
                  <li
                    key={index}
                    className={`text-black text-xs ${
                      index < Math.ceil(formattedGroupCompanies.length / 2) - 1
                        ? "mb-1"
                        : ""
                    }`}
                  >
                    {company}
                  </li>
                ))}
            </ul>
            <ul className="list-disc pl-4">
              {formattedGroupCompanies
                .slice(Math.ceil(formattedGroupCompanies.length / 2))
                .map((company, index) => (
                  <li
                    key={index}
                    className={`text-black text-xs ${
                      index < Math.floor(formattedGroupCompanies.length / 2) - 1
                        ? "mb-1"
                        : ""
                    }`}
                  >
                    {company}
                  </li>
                ))}
            </ul>
          </div>
        </div>

        {/* News Section */}
        <div>
          <div className="font-bold text-left text-xs mb-3">News</div>
          <div>
            {news[clientGroup]?.length > 0 ? (
              news[clientGroup].map((news, index) => (
                <div
                  key={index}
                  className="mb-2 border rounded p-3 cursor-pointer hover:bg-gray-50 relative"
                  style={{
                    borderColor: readNews.includes(news.id) ? "green" : "#A6A6A6",
                  }}
                  onClick={() => handleReadNews(news.id)}
                >
                  <div className="flex justify-between items-start">
                    <div className="text-black font-bold text-xs my-1">
                      {news.title}
                    </div>
                    {readNews.includes(news.id) ? (
                      <DoneIcon sx={{ color: "green", fontSize: 16 }} />
                    ) : (
                      <div className="text-xs text-main animate-pulse underline">
                        Confirm the change
                      </div>
                    )}
                  </div>
                  <div className="text-black text-xs">{news.description}</div>
                </div>
              ))
            ) : (
              <div className="text-gray-500 text-xs">There have been no publicly reported changes in the Board of Directors or Board of Commissioners of {clientName}</div>
            )}
          </div>
        </div>
      </div>
    </Box>
  );
};

export default CompanyProfileSubTab;
